import { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, LucideIcon } from 'lucide-react';

interface FormSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  isCompleted?: boolean;
  icon?: LucideIcon;
}

export function FormSection({ title, description, children, isCompleted = false, icon: Icon }: FormSectionProps) {
  return (
    <Card className={`mb-8 bg-white border border-slate-200 shadow-sm transition-colors duration-200 ${
      isCompleted ? 'border-brand-green/30' : ''
    }`}>
      <CardHeader className="pb-4">
        <div className="flex items-center gap-3">
          {Icon && (
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
              isCompleted ? 'bg-brand-green text-white' : 'bg-slate-100 text-brand-gray'
            }`}>
              <Icon className="h-4 w-4" />
            </div>
          )}
          <div className="flex-1">
            <CardTitle className={`text-xl font-semibold mb-1 ${
              isCompleted ? 'text-brand-green' : 'text-brand-dark'
            }`}>
              {title}
            </CardTitle>
            {description && (
              <CardDescription className="text-brand-gray">{description}</CardDescription>
            )}
          </div>
          {isCompleted && (
            <CheckCircle className="h-5 w-5 text-brand-green" />
          )}
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {children}
      </CardContent>
    </Card>
  );
}